import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import find from 'lodash/find';
import FactsContext from '@Components/Results/substances/contexts/facts.context';
import { MetadataPropTypesShape } from '@Components/Results/MetadataPropTypes';
import SubstanceProperty from '@Components/Results/substances/SubstanceProperty';

function findHitDataFact(facts) {
  return find(facts, (fact) => fact.hitData);
}

function SubstanceHitData({ metadata, substance, database }) {
  const { index: substanceIndex, details } = substance;
  const { facts, toggle } = useContext(FactsContext);
  const fact = findHitDataFact(facts);

  if (!fact) return null;

  return (
    <div
      id={`substances-hitdata-${substanceIndex}`}
      className="substance-results-information u-els-padding-top substances-hit-details"
      aria-expanded>
      <div className="substances-hit-details__container">
        <ul className="rx-accordion medium">
          <SubstanceProperty
            metadata={metadata}
            fact={fact}
            toggle={toggle}
            details={details}
            database={database}
            substanceIndex={substanceIndex}
            substance={substance}
          />
        </ul>
      </div>
    </div>
  );
}

SubstanceHitData.propTypes = {
  metadata: MetadataPropTypesShape,
  substance: PropTypes.object.isRequired,
  database: PropTypes.object.isRequired,
};

export default SubstanceHitData;
